var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImage9(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1000 1000",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M984.2 393.7 808.8 65.9C802.5 56.7 791.8 51.2 780.5 51.2L219.5 51.2C208.1 51.2 197.5 56.7 191.2 65.9L15.8 393.7C7.6 405.6 8.1 421.2 17 432.5L472.8 935.8C479.2 944 489.3 948.8 499.9 948.8 510.5 948.8 520.6 944 527 935.8L982.8 432.5C991.9 421.2 992.4 405.6 984.2 393.7ZM635.7 432.2 500 840 364.3 432.2 635.7 432.2ZM374.4 392.4 500 122.1 625.6 392.4 374.4 392.4ZM545.5 117.7 742.5 117.7 659.7 370.3 545.5 117.7ZM340.3 370.2 257.5 117.6 454.5 117.6 340.3 370.2ZM443.1 788.8 102.9 432.2 321.7 432.2 443.1 788.8ZM678.2 432.2 897.1 432.2 556.9 788.8 678.2 432.2ZM900.8 392.4 694.4 392.4 777.4 139.4 900.8 392.4ZM222.6 139.4 305.7 392.4 99.2 392.4 222.6 139.4Z",
    stroke: "#D6FF41",
    fill: "#D6FF41"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage9);
export default __webpack_public_path__ + "static/media/image9.b987f3a347f2d1eb13b9ed7d09b9e4bb.svg";
export { ForwardRef as ReactComponent };